export default __webpack_public_path__ + "static/media/ISFP-3.c2e6aaa8.png";